module.exports = __webpack_public_path__ + "static/media/CORAL-TUBE_01.a32ea48b.png";